var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row-v-table"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('counsel-card-row', {
    attrs: {
      "label": "작성업체",
      "cols": 12,
      "md": 4
    }
  }, [_vm._v(_vm._s(_vm.request.requester.companyName))])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('counsel-card-row', {
    attrs: {
      "label": "자문요청일",
      "cols": 12,
      "md": 4
    }
  }, [_vm._v(_vm._s(_vm.request.createdAt.toDateTime()))])], 1)], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('view-area', {
    attrs: {
      "area": _vm.request.area
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.isLong ? _c('view-duration', {
    attrs: {
      "request": _vm.request
    }
  }) : _c('counsel-card-row', {
    attrs: {
      "label": "상태",
      "cols": 12,
      "md": 4
    }
  }, [_vm._v(_vm._s(_vm.request.status))])], 1)], 1), _c('counsel-card-row', {
    attrs: {
      "label": "제목"
    }
  }, [_vm._v(_vm._s(_vm.request.title))]), _c('counsel-card-row', {
    attrs: {
      "label": "상세내용"
    }
  }, [_vm._v(_vm._s(_vm.request.content))]), _c('view-files', {
    attrs: {
      "files": _vm.request.files
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }